import { FC, ReactNode } from "react"
import { useObservable } from "src/framework/store/storeUtil";
import { infoOpen$, InfoScreenType, infoSubTitle$, infoTitle$, infoType$ } from "src/store/feedbacks/Info.store";
import theme from "src/theme/light";
import styled from "styled-components";
import { fadeInUp } from "react-animations"
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faInfoCircle, faTimesCircle, faWarning } from "@fortawesome/free-solid-svg-icons";

const InfoScreenBase = styled.div({
    background: theme.palette.background.default,
    width: "100%",
    height: "100%",
    position: "fixed",
    top: "0px",
    left: "0px",
    display: "flex",
    flexDirection: "column",
    zIndex: 1201,
    alignContent: "center",
    justifyContent: "center",
});

const InfoScreenTitle = styled.div({
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
});

const InfoScreenSubTitle = styled.div({
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
});

interface InfoTypeIconProperties {
    color: string;
}

const InfoTypeIcon = styled.div<InfoTypeIconProperties>((props) => ({
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    color: props.color,
    height: "40px"
}))


const getType = (type: InfoScreenType): { color: string, icon: ReactNode } => {

    if (type === "success") {
        return { color: theme.palette.success.main, icon: <><FontAwesomeIcon icon={faCheckCircle} size="4x" height={"100px"} width={"100px"} fixedWidth /></> }
    }

    if (type === "warning") {
        return { color: theme.palette.warning.main, icon: <><FontAwesomeIcon icon={faWarning} size="4x" /></> }
    }

    if (type === "danger") {
        return { color: theme.palette.error.main, icon: <><FontAwesomeIcon icon={faTimesCircle} size="4x" /></> }
    }

    return { color: theme.palette.info.main, icon: <><FontAwesomeIcon icon={faInfoCircle} size="4x" /></> }
}


const InfoScreen: FC = () => {

    const open = useObservable(infoOpen$);
    const title = useObservable(infoTitle$);
    const subTitle = useObservable(infoSubTitle$);
    const type = useObservable(infoType$);

    const { color, icon } = getType(type)

    return <>{
        open && <InfoScreenBase>
            <InfoTypeIcon color={color}>{icon}</InfoTypeIcon>
            <InfoScreenTitle>{title}</InfoScreenTitle>
            <InfoScreenSubTitle>{subTitle}</InfoScreenSubTitle>
            <Button fullWidth={false} onClick={() => {
                infoOpen$.next(false);
            }}>Fechar</Button>
        </InfoScreenBase>
    }
    </>
}

export { InfoScreen }